import React, { useState, useEffect } from "react";
import {
  ButtonBase,
  Dialog,
  DialogContent,
  DialogTitle,
  InputAdornment,
} from "@mui/material";
import { StyledTextField } from "../../../common/components/TextField/styles";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { editComment } from "../../../api/caseApi";
const EditCommentDialog = ({
  open,
  onClose,
  commentId,
  message,
  fetchComments,
}) => {
  const { register, handleSubmit, reset } = useForm({
    resolver: yupResolver(
      yup.object().shape({ message: yup.string().required() })
    ),
    defaultValues: { message: message },
  });

  const submitEditComment = async (values) => {
    await editComment(commentId, values.message);
    await fetchComments();
    reset();
    onClose();
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Edit comment</DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit(submitEditComment)}>
          <StyledTextField
            label="Comment"
            placeholder="Type your comment here"
            {...register("message")}
            sx={{ width: "100%", marginTop: "20px" }}
            multiline
            rows={2}
            InputProps={{
              endAdornment: (
                <ButtonBase type="submit">
                  <InputAdornment>
                    <FontAwesomeIcon icon={faPaperPlane} />
                  </InputAdornment>
                </ButtonBase>
              ),
            }}
          />
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EditCommentDialog;
